import axios from "axios";

const API_URL = "/api/v1/file-rename-templates";

export const getAllFileRenameRules = () => {
  return axios.get(API_URL);
};

export const getFileRenameRuleById = (id) => {
  return axios.get(`${API_URL}/${id}`);
};

export const createFileRenameRule = (data) => {
  return axios.post(API_URL, data);
};

export const updateFileRenameRule = (id, data) => {
  return axios.patch(`${API_URL}/${id}`, data);
};

export const removeFileRenameRule = (id) => {
  return axios.delete(`${API_URL}/${id}`);
};

export const getHierarchicalFileRenamePlaceholders = () => {
  return axios.get(`/api/v1/file-rename-categories/hierarchical`);
};

export const getFileRenameDocumentTypes = (searchString = "") => {
  const params = searchString
    ? {
        search: searchString,
        fuzzySearch: "true",
        searchFields: ["name", "key", "aiValue", "aliases"],
        minConfidence: "0.6",
        maxResults: "50",
      }
    : {};

  return axios.get(`/api/v2/file-rename-templates/document-types`, {
    params,
  });
};

export const getFileRenamePlaceholdersV2 = (searchQuery) => {
  const params = searchQuery
    ? {
        search: searchQuery,
        fuzzySearch: "true",
        searchFields: ["key", "label"],
        minConfidence: "0.6",
        maxResults: "50",
      }
    : {};

  return axios.get(`/api/v2/file-rename-placeholders`, {
    params,
  });
};

export const getAllLenders = () => {
  return axios.get(`/api/v1/lenders`, {
    params: {
      page: 1,
      limit: 100,
    },
  });
};

export const bulkUpdateFileRenameRules = (ruleIds, settings) => {
  return axios.post(`${API_URL}/bulk-update`, {
    ruleIds,
    settings,
  });
};
